import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Loader from '@helsenorge/designsystem-react/components/Loader';
import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';
import { getCorrelationIdList } from '@helsenorge/framework-utils/hn-proxy-service';
import ErrorMessage from '../error-message';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isEmpty(obj) {
    return !obj || Object.keys(obj).length === 0;
}
const PageLoader = props => {
    let data;
    let error = null;
    let warning = null;
    let info = null;
    const spinning = (!props.ignoreResources && isEmpty(props.resources)) || props.loading;
    if (spinning) {
        data = _jsx(Loader, { center: true, ...props.loaderProps });
    }
    else {
        if (props.info) {
            info = (_jsx(NotificationPanel, { variant: 'info', label: props.info, labelId: props.labelId, children: _jsx("p", { children: props.infoDescription }) }, "info"));
        }
        if (props.warning) {
            warning = (_jsxs(NotificationPanel, { variant: 'warn', label: props.warning, labelId: !props.info ? props.labelId : undefined, children: [_jsx("p", { children: props.warningDescription }), _jsx("p", { children: props.warningContent })] }, "warning"));
        }
        if (props.error) {
            const correlationId = getCorrelationIdList()?.join(', ');
            error = (_jsx(ErrorMessage, { label: props.error, labelId: !props.info && !props.warning ? props.labelId : undefined, description: props.errorDescription, correlationId: correlationId }));
            if (props.showChildrenOnError) {
                data = props.children;
            }
        }
        else {
            data = props.children;
        }
    }
    const ariaAttributes = props.live
        ? {
            'aria-busy': spinning,
            'aria-live': 'polite',
        }
        : undefined;
    return (_jsxs("div", { ...ariaAttributes, "data-testid": props.testId, children: [info, warning, error, data] }));
};
export default PageLoader;
